/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserByIdRoleResponse } from './user-by-id-role-response';
import { UserByIdExternalSourceResponse } from './user-by-id-external-source-response';
import { UserByIdStatusResponse } from './user-by-id-status-response';
import { UserByIdTypeResponse } from './user-by-id-type-response';
import { UserByIdTenantResponse } from './user-by-id-tenant-response';


export interface UserByIdResponse { 
    id?: string;
    serialNumber?: number;
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
    login?: string | null;
    email?: string | null;
    emailConfirmed?: boolean;
    phoneNumber?: string | null;
    phoneNumberConfirmed?: boolean;
    externalId?: string | null;
    isBlocked?: boolean;
    blockedDate?: string | null;
    lockoutEndDate?: string | null;
    lastLoginDate?: string | null;
    createdDate?: string;
    updatedDate?: string | null;
    isAdmin?: boolean;
    isAgreementAcceptanceRequired?: boolean;
    status?: UserByIdStatusResponse;
    type?: UserByIdTypeResponse;
    externalSource?: UserByIdExternalSourceResponse;
    roles?: Array<UserByIdRoleResponse> | null;
    tenants?: Array<UserByIdTenantResponse> | null;
}

